module.exports = __webpack_public_path__ + "static/media/bg-800.180dda45.jpeg";